// extracted by mini-css-extract-plugin
module.exports = {"centered":"Login_centered__1A5dv","centeredText":"Login_centeredText__35pXy","form":"Login_form__3nREN","submitButton":"Login_submitButton__2OYMn"};